import React from 'react';
import type { Metadata, MediaEventHandlers, PhotoControls } from './media-displayer';
import PhotoView from './photo-view';

const configuredPhotoView = (
  metadata: Metadata,
  handlers?: MediaEventHandlers & PhotoControls,
): React.ReactElement => {
  const noop = () => {};
  // Always use the original image and let PhotoView scale it responsively to the available
  // width, rather than switching between differently-sized generated variants per viewport
  // (per refinement decision: "Don't use large. Always use original and scale it with the
  // width of the space that's available.").
  const imageHeight = Number(metadata.exif?.pixel_y_dimension);
  const imageWidth = Number(metadata.exif?.pixel_x_dimension);

  return (
    <PhotoView
      imageSrc={metadata.original}
      originalSrc={metadata.original}
      onResize={handlers?.onResize || noop}
      isZoomable={metadata.isZoomable || false}
      photoRef={metadata.ref || null}
      panoramaEnabled={metadata.panoramaEnabled || false}
      switchPhotoViewer={handlers?.switchPhotoViewer || noop}
      dimensions={{
        width: imageWidth,
        height: imageHeight,
      }}
      accessId={metadata.accessID || ''}
      disableRecognition={handlers?.disableRecognition || noop}
      enableRecognition={handlers?.enableRecognition || noop}
    />
  );
};
export default configuredPhotoView;
